module.exports = __webpack_public_path__ + "img/site-banner-1.5b917c0b.jpg";